module.exports = __webpack_public_path__ + "bad573bc597560887ccfad46ef28f33d.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/about/omniderm-logo.jpg
 ** module id = 421
 ** module chunks = 0
 **/